import { Dialog, Stack, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { convertPxToRem } from "@/utils";
import IconLoader from "@/features/Common/components/IconLoader";

interface LifestyleSuccessScreenProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue?: () => void;
}

export default function LifestyleSuccessScreen({
  isOpen,
  onClose,
  onContinue,
}: LifestyleSuccessScreenProps) {
  const { t } = useTranslation();

  const handleContinue = () => {
    onContinue?.();
    onClose();
  };

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      aria-label={t("LifestyleSuccess.title")}
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
        },
      }}
    >
      <Stack
        spacing={4}
        alignItems="center"
        textAlign="center"
        px={4}
        py={6}
        height="100%"
        justifyContent="center"
      >
        <IconLoader
          icon="HandDrawnShieldFaceIcon"
          color="primary"
          sx={{ fontSize: convertPxToRem(160) }}
        />

        <Stack spacing={1} maxWidth={convertPxToRem(280)}>
          <Typography variant="h2" fontWeight={700}>
            {t("LifestyleSuccess.title")}
          </Typography>
          <Typography variant="body1" color="neutral.700">
            {t("LifestyleSuccess.description")}
          </Typography>
        </Stack>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleContinue}
        >
          {t("LifestyleSuccess.cta")}
        </Button>
      </Stack>
    </Dialog>
  );
}
